<template>
    <PopupRouterView :showLeftIcon="true" label="Put Away Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="putaway"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="putAwayInput">


        <b-card header="Put Away" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-datepicker  id="fieldset-put-away-date" label-cols-lg="12"  label="Date" size="sm" :model.sync="model.putAwayDate" :isRequired="true" :state="validateState('putAwayDate')" :errorMessage="getErrorMessage(errorMessage.putAwayDate, 'putAwayDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  />
						<app-input-radio :options="putAwayCategorys" text-field="name" value-field="id" label-cols-lg="12" label="PutAwayType" id="fieldset-put-away-type" size="sm" :model.sync="model.putAwayTypeId"   />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <b-card header="Picking" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="ControlCard" id="fieldset-control-card" size="sm" :model.sync="model.controlCardId"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards"   :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCard" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <b-card header="Posting" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" label="Control Card Number" :model="(model.controlCard != null) ? model.controlCard.controlCardNumber : null"  />
						<app-input-combobox-autocomplete :options="racks" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Rack" id="fieldset-rack" size="sm" :model.sync="model.rackId"   :selected="model.rack != null ? model.rack.code : ''" @input="getRacks"   :isSelectMethodExists="true" @onSelectMethod="setSelectedRack" />
						<app-input-textarea id="fieldset-remark" label-cols-lg="12"  label="Remark" label-for="input-remark" size="sm" :model.sync="model.remark"   />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <b-card header="Scanner ID Supervisor" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="Approval" id="fieldset-approval" size="sm" :model.sync="model.approvalUserName"   :selected="model.approval != null ? model.approval.firstName : ''" @input="getUserInfos"   :isSelectMethodExists="true" @onSelectMethod="setSelectedApproval" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PutAway from '@/models/PutAway/PutAway';
import PutAwayList from '@/models/PutAway/PutAwayList';
import PutAwayFilter from '@/filters/PutAway/PutAwayFilter';

import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputRadio from '@/components/AppInputRadio';
import PutAwayCategory from '@/models/PutAwayCategory/PutAwayCategory';
import PutAwayCategoryFilter from '@/filters/PutAwayCategory/PutAwayCategoryFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppLabel from '@/components/AppLabel';
import Rack from '@/models/Rack/Rack';
import RackFilter from '@/filters/Rack/RackFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputRadio,
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputTextarea,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			putAwayDate: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				putAwayDate: { required : "Date is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterPutAway : null,
			currentPutAwayPage : 1,
			putAwayPageSize: 10,
			sortByPutAway: '',
			sortDescPutAway: '',
			putAwayCategorys: [],
			putAwayTypes: [],
			isPutAwayTypeComboLoading: false,
			controlCards: [],
			controlCards: [],
			isControlCardComboLoading: false,
			racks: [],
			racks: [],
			isRackComboLoading: false,
			userInfos: [],
			approvals: [],
			isApprovalComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPutAwayCategoryComboLoading: false,
			isControlCardComboLoading: false,
			isRackComboLoading: false,
			isUserInfoComboLoading: false,
		}
	},
	methods : {
		getPutAway : async function(id) {
			this.isBusy = true;
			PutAway.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.controlCardId != null) {
					promises.push(
						this.getControlCard(this.model.controlCardId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPutAway = true;
			this.filterPutAway.id = this.modelId;
			PutAway.downloadDataDetail(this, this.filterPutAway).then(result => {
				this.isDownloadPutAway = false;
			}).catch(error => { this.isDownloadPutAway = false; })
		},
		getPutAways : async function(input) {
			let filter = new PutAwayFilter();
			if (input != undefined) {
				filter.PutAwayDate = input;
			}
			this.isPutAwayComboLoading = true;
			PutAway.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.putAways = result.data
				}
				this.isPutAwayComboLoading = false;
			})
			.catch(error => {});
		},
		getPutAwayCategorys : async function(input) {
			let filter = new PutAwayCategoryFilter();
			if (input != undefined) {
				filter.name = input;
			}
			PutAwayCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.putAwayCategorys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPutAwayType(item) {
			if(item == undefined || item == null) {
				this.model.putAwayTypeId = null;
				this.model.putAwayType = null;
			} else {
				this.model.putAwayTypeId = item.id;
				this.model.putAwayType = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getRacks : async function(input) {
			let filter = new RackFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Rack.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.racks = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedRack(item) {
			if(item == undefined || item == null) {
				this.model.rackId = null;
				this.model.rack = null;
			} else {
				this.model.rackId = item.id;
				this.model.rack = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedApproval(item) {
			if(item == undefined || item == null) {
				this.model.approvalUserName = null;
				this.model.approval = null;
			} else {
				this.model.approvalUserName = item.userName;
				this.model.approval = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getControlCard : async function(id) {
			ControlCard.getData(this, id).then(result => {
				this.model.controlCard = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.putAwayInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						PutAway.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'putawayindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						PutAway.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'putawayindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PutAway.updateData(this, model, id)
					.catch((error) => {
						this.getPutAway(id);
					});
				}
			});
		},
		onHidden() {
			this.getPutAways();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterPutAway = new PutAwayFilter();
		this.getPutAwayCategorys();
		//this.getControlCards();
		//this.getRacks();
		//this.getUserInfos();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPutAway(id);
			} else {
				this.modelId = id;
				this.getPutAway(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
